export default "__VITE_ASSET__GNryD2g3__"